(function () {
  'use strict';

  angular
    .module('itecAdministracio.rols.main.submain.dades')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('rols.main.submain.dades', {
        url: '/dades',

      views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(permisosRolsHeaderSubmenuLinksValue){
                return permisosRolsHeaderSubmenuLinksValue;
              }
            }
          },
          'content@rols.main.submain': {
            templateUrl: 'rols/main/dades/dades.tpl.html',
            controller: 'RolsMainDadesCtrl',
            controllerAs: 'ctrl'
          }
        },
        breadcrumb: 'DEFAULT_DADES_GENERALS'
      });
  }
}());
